<template>
  <div class="column-view">
    <div class="margin-bottom-10" v-if="list.length > 0">
      <el-button @click="exportExcel" icon="el-icon-download" type="primary"
        >导出为Excel</el-button
      >
    </div>
    <el-table ref="table" :data="list" v-loading="loading">
      <el-table-column label="领导班子年度考核测评结果汇总" align="center">
        <el-table-column label="部门" width="250px" align="center">
          <template slot-scope="scope">
            {{ scope.row.department.dept_name }}
          </template>
        </el-table-column>
        <el-table-column label="测评人数" align="center">
          <el-table-column label="合计" width="100px" align="center">
            <template slot-scope="scope">
              {{
                Number(scope.row.join_first_meeting_number) +
                Number(scope.row.join_second_meeting_number)
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="山西局年度考核述职测评会"
            width="100px"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.join_first_meeting_number || "" }}
            </template>
          </el-table-column>
          <el-table-column
            label="部门（单位）考核述职测评会"
            width="100px"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.join_second_meeting_number || "" }}
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="局领导" align="center">
          <el-table-column
            label="平均分值"
            width="100px"
            align="center"
            prop="bureau_leader_avg"
          >
          </el-table-column>
        </el-table-column>

        <el-table-column label="总师" align="center">
          <el-table-column
            label="平均分值"
            width="100px"
            align="center"
            prop="chief_engineer_avg"
          >
          </el-table-column>
        </el-table-column>

        <el-table-column label="各部门（局属单位）" align="center">
          <el-table-column
            label="平均分值"
            width="200px"
            align="center"
            prop="chief_executive_avg"
          >
          </el-table-column>
        </el-table-column>

        <el-table-column label="其他人员" align="center">
          <el-table-column
            label="平均分值"
            align="center"
            prop="other_people_avg"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="弃权" align="center">
          <el-table-column label="票数" align="center" prop="abstain_number">
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="评价结果分值"
          width="150px"
          align="center"
          prop="score_result"
        >
        </el-table-column>
      </el-table-column>
      <template #empty>
        <yc-no-content des="暂未生成数据汇总表"></yc-no-content>
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "secondTable",
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  methods: {
    showLoading() {
      this.loading = true;
    },
    setData(list) {
      this.list = list;
      this.loading = false;
    },
    exportExcel() {
      this.$commonUtils.exportExcel(this.$refs.table, "领导班子年度考核测评");
    },
  },
};
</script>

<style scoped></style>
